import {
  EventNote,
  Face,
  Home,
  MonetizationOn,
  PeopleAlt,
  Toys,
} from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import "./Navbar.css";

const border = "5px solid #ffd800";

function Navbar() {
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState("Home");

  const pageHandler = (pageName) => {
    history.push(`/${pageName}`);
    setCurrentPage(pageName);
  };

  useEffect(() => {
    history.push("/Home");
    // eslint-disable-next-line
  }, []);
  // console.log("rendered");
  return (
    <div className="navbar">
      <div
        style={{
          borderBottom: currentPage === "Home" ? border : null,
        }}
        onClick={() => pageHandler("Home")}
      >
        <Face /> <div>User Data</div>
      </div>

      <div
        style={{
          borderBottom: currentPage === "Homepage" ? border : null,
        }}
        onClick={() => pageHandler("Homepage")}
      >
        <Home /> <div>Homepage</div>
      </div>

      <div
        style={{
          borderBottom: currentPage === "Events" ? border : null,
        }}
        onClick={() => pageHandler("Events")}
      >
        <EventNote /> <div>Events</div>
      </div>

      <div
        style={{
          borderBottom: currentPage === "CommunityMembers" ? border : null,
        }}
        onClick={() => pageHandler("CommunityMembers")}
      >
        <PeopleAlt /> <div>Committe Members</div>
      </div>

      <div
        style={{
          borderBottom: currentPage === "Donations" ? border : null,
        }}
        onClick={() => pageHandler("Donations")}
      >
        <MonetizationOn /> <div>Donations</div>
      </div>

      <div
        style={{
          borderBottom: currentPage === "Skills" ? border : null,
        }}
        onClick={() => pageHandler("Skills")}
      >
        <Toys /> <div>Skills</div>
      </div>
    </div>
  );
}

export default Navbar;
